"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRelativeTotals = exports.calculateDiscountedElectricity = void 0;
const constants_1 = require("../constants");
const solution_1 = require("../solution");
const money_1 = require("./money");
const { calculations } = constants_1.constants;
// The amount of kWh consumption over 10.000 that gets discounted, e.g. if you consume 15.000kWh
// and are going to produce 8.000kWh, you save 5.000 discounted kWh and 3.000 non-discounted kWh
// Example calcs: https://www.gaslicht.com/userfiles/File/pdf/energie/productalgemeen/Informatiebladterugleveringzonconsumenten.pdf
// TODO: this method could use somewhat clearer documentation
function calculateDiscountedElectricity(electricityConsumption, electricityProduction) {
    if (electricityConsumption > calculations.kwhDiscountMinimum) {
        return Math.min(electricityProduction, electricityConsumption - calculations.kwhDiscountMinimum);
    }
    return 0;
}
exports.calculateDiscountedElectricity = calculateDiscountedElectricity;
/**
 * This function returns an object that takes into account the gasFactors of the separate quptes or estimates
 * @param estimates information about what will change (can be quotes or estimates)
 * @param consumption current consumption of the house
 * @param energyPrices energy prices used to calculate how much money will be saved
 * @returns the relative savings totals for the situation
 */
function calculateRelativeTotals(estimates, consumption, energyPrices = constants_1.constants.energyPrices) {
    let totalEnergyIndex = 0;
    let newGasConsumption = consumption.gas;
    let totalElectricityProduction = 0;
    let totalElectricityConsumption = 0;
    estimates.forEach(estimate => {
        totalEnergyIndex += estimate.energyDelta.energyIndex;
        newGasConsumption -= newGasConsumption * estimate.energyDelta.gasFactor;
        totalElectricityProduction += estimate.energyDelta.electricityProduction;
        totalElectricityConsumption += estimate.energyDelta.electricityConsumption;
    });
    const isHeatPumpQuote = (q) => [solution_1.Solution.HybridHeatPump, solution_1.Solution.ElectricHeatPump].includes(q.solution);
    const hasHeatPump = estimates.some(quote => isHeatPumpQuote(quote));
    let insulationGasFactor = 1;
    if (hasHeatPump) {
        // Can only enable one type of heat pump at a time for calcs
        const heatPumpQuote = estimates.find(quote => isHeatPumpQuote(quote));
        estimates.forEach(quote => {
            if (!isHeatPumpQuote(quote)) {
                insulationGasFactor = insulationGasFactor * (1 - quote.energyDelta.gasFactor);
            }
        });
        totalElectricityConsumption =
            totalElectricityConsumption -
                heatPumpQuote.energyDelta.electricityConsumption -
                200 +
                (heatPumpQuote.energyDelta.electricityConsumption + 200) * insulationGasFactor;
    }
    const totalGasSavings = consumption.gas - newGasConsumption;
    const totalElectricitySavings = totalElectricityProduction + totalElectricityConsumption;
    const money = (0, money_1.getYearlyFinancialSavings)(consumption, {
        gasConsumption: totalGasSavings,
        electricityConsumption: totalElectricityConsumption,
        electricityProduction: totalElectricityProduction,
    }, energyPrices).total;
    return {
        money,
        gasConsumption: totalGasSavings,
        electricityConsumption: totalElectricityConsumption,
        electricityProduction: totalElectricityProduction,
        emission: totalGasSavings * constants_1.constants.emissionFactors.gas +
            totalElectricitySavings * constants_1.constants.emissionFactors.electricity,
        energyIndex: totalEnergyIndex,
    };
}
exports.calculateRelativeTotals = calculateRelativeTotals;
